import { OktaAuth } from "@okta/okta-auth-js";

const config = {
  baseUrl: window?.__ENV?.OKTA_BASE_URL,
  clientId: window?.__ENV?.OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/redirecting`,
  postLogoutRedirectUri: `${window.location.origin}`,
  authParams: {
    issuer: window?.__ENV?.OKTA_ISSUER,
    scopes: ["openid", "profile", "email"],
    pkce: true,
  },
};

const authClient = new OktaAuth({
  issuer: window?.__ENV?.OKTA_ISSUER,
  clientId: config.clientId,
  redirectUri: config.redirectUri,
  postLogoutRedirectUri: `${window.location.origin}`,
  storageManager: {
    token: {
      storageType: "sessionStorage",
    },
    cache: {
      storageType: "sessionStorage",
    },
  },
  scopes: config.authParams?.scopes,
  multiOptionalFactorEnroll: true,
  pkce: true,
});

export default authClient;
